export default {
    CREATE_POOL: 'sortable/CREATE_POOL',
    DELETE_POOL: 'sortable/DELETE_POOL',
    SORT_POOL: 'sortable/SORT_POOL',
};
